var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[(_vm.unreadEventsCount > 0)?_c('small',{staticClass:"label pull-right bg-green"},[_vm._v(_vm._s(_vm.unreadEventsCount))]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b4cf85c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin-panel/components/sidebar/unreadEventsCount.vue
// module id = jRS9
// module chunks = 0